;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "MackerCheckerFilter",
  props: {
    period: {
      type: String,
      default: "Select Period..."
    },
    existingFilters: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      searchQuery: "",
      selectedPeriod: "",
      date_range: [],
      showCalender: false
    };
  },
  mounted: function mounted() {
    this.date_range = this.existingFilters.date_range || [];

    if (this.period === "Custom") {
      this.showCalender = true;
    }
  },

  methods: {
    toggleCalender: function toggleCalender() {
      if (this.selectedPeriod === "Custom") {
        this.showCalender = true;
        this.date_range = [];
      } else {
        this.showCalender = false;
        this.date_range = [];
        var filters = {
          search: this.searchQuery,
          selectedPeriod: this.selectedPeriod,
          date_range: this.date_range
        };
        this.$emit("filterDetails", filters);
      }
    },
    clearDateFilter: function clearDateFilter() {
      this.selectedPeriod = "";
      this.date_range = [];
      this.showCalender = false;
    },
    submit: function submit() {
      var filters = {
        search: this.searchQuery,
        selectedPeriod: this.selectedPeriod,
        date_range: this.date_range
      };
      this.$emit("filterDetails", filters);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('div',{staticClass:"d-flex align-items-start"},[_c('div',{staticClass:"flex-grow-1 mr-3"},[_c('div',{staticClass:"input-group input-group-flush border border-gray-400 rounded-lg px-2 w-100"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Search by unique identifier"},domProps:{"value":(_vm.searchQuery)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group mb-0",staticStyle:{"min-width":"220px"}},[(!_vm.showCalender)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPeriod),expression:"selectedPeriod"}],staticClass:"form-control filters js-example-basic-single",attrs:{"id":"s3-multiple2"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedPeriod=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.toggleCalender]}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.period))]),_vm._v(" "),_c('option',{attrs:{"value":"Today"}},[_vm._v("Today")]),_vm._v(" "),_c('option',{attrs:{"value":"Yesterday"}},[_vm._v("Yesterday")]),_vm._v(" "),_c('option',{attrs:{"value":"Custom"}},[_vm._v("Custom")])]):_vm._e(),_vm._v(" "),(_vm.showCalender)?_c('vue-datepicker',{attrs:{"format":"YYYY-MM-DD HH:mm:ss","range-separator":"-","value-type":"format","shortcuts":false,"type":"date","confirm":true,"width":"100%","lang":"en","placeholder":"Select date range...","range":true,"input-class":"form-control","append-to-body":true},on:{"confirm":_vm.submit,"clear":_vm.clearDateFilter},model:{value:(_vm.date_range),callback:function ($$v) {_vm.date_range=$$v},expression:"date_range"}}):_vm._e()],1)])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('span',{staticClass:"fe fe-search"})])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bad8c79a", __vue__options__)
  } else {
    hotAPI.reload("data-v-bad8c79a", __vue__options__)
  }
})()}